import {
  LanguageTestTemplate,
  LanguageTestTemplateInput
} from '../../lib/types/models/language-test/language-test-template'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createLanguageTestTemplate = (data: LanguageTestTemplateInput) =>
  restApiClient
    .url(API.languageTest.createTemplate.url)
    .post<LanguageTestTemplate, LanguageTestTemplateInput>(data)
